exports = module.exports = require("../../../../../vuesora/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination{height:30px}.page-button{min-width:30px;width:30px;min-height:30px;height:30px;margin:0 3px;cursor:pointer}.page-button.active,.page-button.filler{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../vuesora/node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fb6db06","scoped":false,"hasInlineConfig":true}!../vuesora/node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vuesora/src/components/Pagination.vue
// module id = w9jL
// module chunks = 0 3